import React, {PureComponent} from 'react';
import {Table} from 'reactstrap';
import PropTypes from 'prop-types';

export default class TableComponent extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        hover: PropTypes.bool,
        responsive: PropTypes.bool,
        striped: PropTypes.bool
    };

    render() {
        return (
            <Table className={this.props.className} striped={this.props.striped} hover={this.props.hover}
                   responsive={this.props.responsive}>
                {this.props.children}
            </Table>
        )
    }
}


// WEBPACK FOOTER //
// ./src/theme/components/table/Table.js